import Sidebar from "./Sidebar";
import Header from "./Header";
import React, { useState, useEffect, createContext, useContext, useCallback } from "react";

const SidebarContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
  toggle: () => {},
});

export const useSidebar = () => useContext(SidebarContext);

const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setIsOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <SidebarContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
};

const Layout = ({ children }) => (
  <SidebarProvider>
    <div className="flex min-h-screen overflow-x-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0
                      lg:ml-[19.5rem]
                      main-no-sidebar">
        <Header />
        <main className="flex-1 mt-16 p-4 sm:p-6 lg:p-8 pt-24 lg:pt-24 max-w-full">
          {children}
        </main>
      </div>
    </div>
  </SidebarProvider>
);

export default Layout;
